import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const pollCss = ".poll{max-width:16rem;display:flex;flex-direction:column;row-gap:1rem;font:var(--tt-font-standard)}";

const Poll = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.label = undefined;
  }
  /** Force update the values */
  async update() {
    var _a;
    (_a = this.element) === null || _a === void 0 ? void 0 : _a.querySelectorAll('tt-poll-answer').forEach((p) => p.update());
  }
  connectedCallback() {
    this.update = this.update.bind(this);
  }
  render() {
    return (h("div", { part: "base", class: "poll" }, h("div", { class: "poll-title" }, this.label), h("slot", { onSlotchange: this.update })));
  }
  get element() { return this; }
  static get style() { return pollCss; }
}, [1, "tt-poll", {
    "label": [1],
    "update": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-poll"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-poll":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Poll);
      }
      break;
  } });
}

const TtPoll = Poll;
const defineCustomElement = defineCustomElement$1;

export { TtPoll, defineCustomElement };
